<template>
    <div class="inline-flex">
        <button
            class="btn is-danger"
            :disabled="group.addresses_count > 0"
            :title="group.addresses_count > 0 ? 'Gruppen har kopplade adresser och kan därför inte raderas' : ''"
            @click="$modal.show('delete-group')"
        >
            Radera
        </button>
        <adaptive-form-modal
            name="delete-group"
            :primary-button-text="`Radera ${group.name}`"
            primary-button-class="is-danger"
            :title="`Radera ${group.name}`"
            :redirect-to="route('admin.sales-projects.addresses.index', project)"
            :action="route('api.sales-projects.groups.destroy', [project, group])"
            method="delete"
        >
            Vill du verkligen radera gruppen {{ group.name }}?
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            project: {
                required: true,
                type: Object,
            },
            group: {
                required: true,
                type: Object,
            },
        },
    };
</script>
